import { Clear, Search } from '@mui/icons-material';
import { IconButton, InputAdornment, SvgIcon, TextField } from '@mui/material';
import { ChangeEvent, ComponentProps, FC, Ref } from 'react';

interface Props extends ComponentProps<'div'> {
    label?: string;
    placeholder: string;
    resetInputField: () => void;
    updateUserInput: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    value: string;
    // biome-ignore lint/suspicious/noExplicitAny: inputRef can be of any type
    inputRef?: Ref<any>;
}

const Searchbar: FC<Props> = ({ label, placeholder, resetInputField, updateUserInput, value, inputRef }) => {
    return (
        <TextField
            inputRef={inputRef}
            fullWidth
            label={label}
            placeholder={placeholder}
            value={value}
            onChange={(event) => updateUserInput(event)}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SvgIcon fontSize="inherit">
                                <Search />
                            </SvgIcon>
                        </InputAdornment>
                    ),
                    ...(value.length > 0 && {
                        endAdornment: (
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => {
                                    resetInputField();
                                }}
                            >
                                <Clear fontSize="inherit" />
                            </IconButton>
                        ),
                    }),
                },

                htmlInput: { 'aria-label': 'search' },
            }}
        />
    );
};

export default Searchbar;
